import clsx from 'clsx'
import { useRef, type ReactNode } from 'react'
import { TextField, type AutocompleteRenderInputParams } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useSearchInputKeyboardNavigation } from './useSearchInputKeyboardNavigation'
import styles from './SearchInput.module.scss'

type SearchInputProps = {
  params: AutocompleteRenderInputParams
  placeholder?: string
  endAdornment?: ReactNode
  showEndAdornment?: boolean
  onSearch?: () => void
  onSearchTab?: () => void
  onSearchEnter?: () => void
}

export const SearchInput = (props: SearchInputProps) => {
  const {
    showEndAdornment,
    endAdornment,
    placeholder,
    params,
    onSearch,
    onSearchTab,
    onSearchEnter,
  } = props

  const inputRef = useRef<HTMLInputElement>(null)
  useSearchInputKeyboardNavigation(inputRef)

  return (
    <div id="searchInputWrapper" className={styles.wrapper}>
      <TextField
        {...params}
        inputRef={inputRef}
        placeholder={placeholder}
        classes={{
          root: clsx(styles.inputRoot, {
            [styles.withAdornment]: showEndAdornment,
          }),
        }}
        slotProps={{
          htmlInput: {
            ...params.inputProps,
            'data-track-id': 'searchBox',
          },
          input: {
            ...params.InputProps,
            endAdornment,
            onKeyDown: (e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                onSearchEnter?.()
              }
              if (e.key === 'Tab') {
                e.preventDefault()
                onSearchTab?.()
              }
            },
          },
        }}
      />
      <div
        className={styles.searchIcon}
        data-track-id="searchButton"
        onClick={(e) => {
          e.preventDefault()
          onSearch?.()
        }}
      >
        <SearchIcon />
      </div>
    </div>
  )
}
